import React, { useMemo } from "react";
import { Dropdown } from "rsuite";

export default function ClocksContextMenu({ show, position, contextMenuList, setShow, container }) {
    const positionMemo = useMemo(() => {
        if (container?.current) {
            const bottomSpace = window.innerHeight - container.current.getBoundingClientRect().top - position.y;
            const rightSpace = window.innerWidth - container.current.getBoundingClientRect().left - position.x;
            const dropdownHeight = 370;
            const dropdownWidth = 245;
            return {
                y: bottomSpace < dropdownHeight ? position.y - dropdownHeight : position.y,
                x: rightSpace < dropdownWidth ? position.x - dropdownWidth : position.x,
            };
        } else return position;
    }, [container, position]);

    return (
        <Dropdown
            open={show}
            renderToggle={() => false}
            className="position-absolute"
            style={{ top: `${positionMemo.y}px`, left: `${positionMemo.x}px` }}
            onToggle={val => setShow(val)}>
            {contextMenuList
                .filter(x => x)
                .map((item, index) =>
                    item.divider ? (
                        <Dropdown.Separator key={index} />
                    ) : (
                        <Dropdown.Item eventKey={index} key={index} onSelect={item.func} disabled={item.disabled} shortcut={item.key?.replace("CTRL", "⌃")}>
                            {item.title}
                        </Dropdown.Item>
                    )
                )}
        </Dropdown>
    );
}
